import { render, staticRenderFns } from "./roundSimple.vue?vue&type=template&id=460c2be6&"
import script from "./roundSimple.vue?vue&type=script&lang=js&"
export * from "./roundSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports